import Tooltip from './Tooltip';

export { Tooltip };
export { IconTooltip } from './IconTooltip';
export { TooltipType } from './constants';
export default Tooltip;
